import { mapState } from 'vuex';
import f from "@/application/shared/functions.js"


export default {
    name: 'licence',
    props: {
    },

    data : function(){

        return {
            loading : false,
            error : null,
            myplans : {}
        }

    },

    created() {

        this.load()

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,

        currency : function(){
            return 'rub'
        },

        product : function(state) {

            if(!this.userinfo) return []

            return _.filter(this.core.appInfo.plans, (p) => {

                return (p.usertypes || []).indexOf(this.userinfo.type) > -1
            })

        },

        myfeatures : state => state.features,
        userinfo : state => state.userinfo?.userinfo,

        features : function(){
            return this.product
        },

        cdv : function(){
            return this.core.cordovakit.purchases.available
        },

        owned : function(state){

            if(!this.cdv) return false

            return _.find(state.cdvproducts || [], (p) => {
                return p.owned
            }) ? true : false
        },

       
    }),

    methods : {
        managecdv : function(){

            this.core.parental('subscription', {}, () => {

                if (f.isios()) {
                    f.openlink("https://apps.apple.com/account/subscriptions");
                } else if (platform.includes('android')) {
                    f.openlink(`https://play.google.com/store/account/subscriptions?package=app.snippity`);
                }

            }, null, null, true)
            
        },
        buy : function(plan){

            this.core.parental('subscription', {}, () => {

                this.core.vueapi[this.cdv ? 'cdvpayment' : 'setpayment']({
                    plan
                })
                
            }, null, null, true)
           
        },

        load : function(){
            this.loading = true

            this.core.api.payments.userplans().then(plans => {

                var mp = {}

                _.each(plans, (pl) => {
                    if(pl.active){
                        mp[pl.id] = pl
                        mp[pl.name] = pl
                    }
                })

                this.myplans = mp

            }).catch(e => {
                console.error(e)
                this.error = e 
            }).finally(() => {
                this.loading = false
            })
        },

        cancelRebillQuestion : function(){

            this.core.parental('subscription', {
			}, () => {

                this.$dialog.confirm(
                    this.$t('plans.cancelRebillQuestion'), {
                    okText: this.$t('yes'),
                    cancelText : this.$t('no')
                })
        
                .then((dialog) => {

                    this.cancelRebill()

                }).catch( e => {
                    
                })

            }, null, null, true)
        },

        cancelRebill : function(){
            this.core.api.payments.cancelSubscription().then(() => {
                this.load()

                this.$store.commit('icon', {
                    icon : 'success',
                    message : this.$t('plans.cancelledRebill')
                })
                
            })
        },

        privacy : function(){
            this.core.vueapi.privacy()
        },

        terms : function(){
            this.core.vueapi.terms()
        },

        

        
    },
}